import { createTheme } from '@mui/material/styles'

export const theme = createTheme({})

export * from './global.styles'
